
import { Cooks, Ingredients, MenuId } from '@/entity/entity'
import { Route } from '@/entity/route'
import router from '@/router'
import { StorageAccess } from '@/scripts/storage-access'
import { generateId } from '@/scripts/util'
import Vue from 'vue'
export default Vue.extend({
  name: 'SearchByKeyword',
  props: {
    cooks: {
      type: Object as () => Cooks,
      required: true
    },
    ingredients: {
      type: Object as () => Ingredients,
      required: true
    }
  },
  data: function () {
    return {
      step: 1,
      listLink: Route.MenuList.path,
      keywordLink: Route.SearchByKeyword.path,
      searchLink: Route.Search.path,
      cookId: ''
    }
  },
  computed: {
    cookList: function () : { id: string, name: string }[] {
      const res: { id: string, name: string }[] = []
      for (const key in this.cooks) {
        if (this.cooks[key].name.indexOf(this.$route.query.key as string) !== -1) {
          res.push({
            id: key,
            name: this.cooks[key].name
          })
        }
      }
      return res
    }
  },
  methods: {
    chooseCook: function (id: string) {
      if (!this.cooks[id]) return
      this.cookId = id
      this.step = 2
    },
    backToStepChooseCook: function () {
      this.step = 1
    },
    saveMenu: function (e: MouseEvent) {
      e.preventDefault()
      const menus = StorageAccess.getMenus()
      menus.push({
        id: generateId() as MenuId,
        name: this.cooks[this.cookId].name,
        ingredients: this.cooks[this.cookId].ingredients.map(x => ({
          id: x.id,
          name: x.name,
          grams: x.consumption,
          origin: x.origin
        }))
      })
      StorageAccess.setMenus(menus)
      router.push(Route.MenuList.path)
    }
  }
})
